import { api } from "../../lib";

export interface SalesRep {
  id: string;
  name: string;
  address: string | null;
  deal: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateSalesRepInput {
  name: string;
  address?: string;
  deal?: string;
}

export interface UpdateSalesRepInput extends Partial<CreateSalesRepInput> {
  id: string;
}

export const salesRepsService = {
  getAll: async () => {
    return api.get<SalesRep[]>("/admin/sales-reps");
  },

  getById: async (id: string) => {
    return api.get<SalesRep>(`/admin/sales-reps/${id}`);
  },

  create: async (input: CreateSalesRepInput) => {
    return api.post<SalesRep>("/admin/sales-reps", input);
  },

  update: async (input: UpdateSalesRepInput) => {
    const { id, ...updates } = input;
    return api.put<SalesRep>(`/admin/sales-reps/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/sales-reps/${id}`);
  },
};
